const removeAreasOfExpertise = ids => ({
  type: 'REMOVE_AREA_OF_EXPERTISE',
  ids,
});

export default removeAreasOfExpertise;
